import React, { useState, useRef } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  Grid,
  TableContainer,
  Table,
  TextField,
  InputLabel,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Card,
  CardContent
} from "@mui/material";
import { ReactComponent as UploadFileIcon } from "../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";
import PhoneInputController from "../../../CommonComponents/PhoneInputController";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function DentalAdd() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const allLanguages = useSelector((state) => state.language.languageList)
  const [loading, setLoading] = useState(false)

  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
    register,
    watch,
  } = useForm({
    mode: "onTouched",
  });

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"], // toggled buttons
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"], // superscript/subscript
    ],
  };

  const headerDatas = {
    title : '',
    description : ''
  }

  const [activeLanguagesHeader, setActiveLanguagesHeader] = useState(allLanguages);

  const [header, setHeader] = useState({
    en : { ...headerDatas }
  })


  const addHeaderLanguage = () => {
    const nextLanguage = allLanguages.find(lang => !activeLanguagesHeader.some(active => active.value === lang.value))
    if(nextLanguage){
      setActiveLanguagesHeader((prev) => [...prev, nextLanguage])
      setHeader((prev => ({...prev, [nextLanguage.value] : { ...headerDatas }})))
    }
}


  const Imgwatch = watch("img");

  const imgFile = useRef();

  const [Newsdata, setNewsdata] = useState({
    title: "",
    description: "",
    img: "",
  });

  const onSubmit = async (data) => {
    console.log(data);

    const formData = new FormData();

    formData.append("title", JSON.stringify(data?.title));
    formData.append("description", JSON.stringify(data?.description));
    formData.append("location", JSON.stringify(data?.location));
    formData.append("Location", JSON.stringify(data?.Location));
    formData.append("contact", JSON.stringify(data?.contact));
    formData.append("email", JSON.stringify(data?.email));
    formData.append("img", data?.img);

    setLoading(true)
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}add-dental-clinic`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setLoading(false)
    navigate("/Admin/dental");
      console.log(response);
    } catch (error) {
      console.log(error);
      setLoading(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  console.log(Imgwatch, 'imgwatch')

  return (
    <>
    <Box>
 <ArrowBackIcon sx={{':hover' : {cursor : 'pointer'}}} onClick={() => navigate('/Admin/dental')}/>
</Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
      
      <Card sx={{ width: '80%', border:'1px solid #E5E7EB', borderRadius:"6px"}}>
        <CardContent style={{ padding: 0, margin: 0 }}>
        <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              borderRadius:'6px 6px 0px 0px'
              
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography variant="h6_1">Dental Clinic Details</Typography>
          </Box>

        <form onSubmit={handleSubmit(onSubmit)}>

        <Box sx={{ width: "100%", p : 2 }}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.email ? "Dental Email*" : "Dental Email*"}
            </InputLabel>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter dental email"
                  error={Boolean(errors?.email) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.email ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.email ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.email?.message}
              </Typography>
            ) : null}
          </Box>
          <Divider sx={{mt : 2, mb : 2}}/>

        {activeLanguagesHeader.map((lang) => (
          <Box sx={{mb: 2}} key={lang.value} >
          <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2, ml : 2}}>{lang.name}</Typography>
          <Box style={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}>{errors?.title?.[lang.value] ? 'Title*' : 'Title'}</InputLabel>
              <Controller
                name={`title.${lang.value}`}
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <TextField
                    error={Boolean(errors?.title?.[lang.value]) ? true : false}
                    {...field}
                    placeholder={`Title for ${lang.name}`}
                    sx={{ 
                        mt: 0, 
                        backgroundColor : 'rgb(249, 250, 251)',
                        borderRadius: 0, 
                        "& .MuiInputBase-input": {
                          color: errors?.title?.[lang.value] ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.title?.[lang.value] ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.title?.[lang.value] ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.title?.[lang.value] ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                  />
                )}
              />
              {errors?.title?.[lang.value] ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter title</Typography> : null}
              </Box>
           
              <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}>{errors?.description?.[lang.value] ? 'Description*' : 'Description'}</InputLabel>
              <Controller
                 name={`description.${lang.value}`}
                rules={{ required: true }} 
                control={control}
                render={({ field }) => (
                  <ReactQuill
                    style={{ height: "180px" }}
                    modules={modules}
                    maxLength={3000}
                    {...field}
                  />
                )}
              />
            </Box>
            <Box style={{ marginTop : '2rem', marginLeft : '1rem'}}>
            {errors?.description?.[lang.value] ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter description</Typography> : null}
            </Box>

            <Divider sx={{mt : 6, mb : 2}}/>
            </Box>  
             ))}

<Box sx={{ width: "100%", p: 2 }}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.location ? "Dental Location*" : "Dental Location*"}
            </InputLabel>
            <Controller
              name="location"
              control={control}
              rules={{ required: "Location is required",
              maxLength: {
                value: 250,
                message: "Location cannot exceed 250 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter location"
                  error={Boolean(errors?.location) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.location ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.location
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.location
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.location
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.location ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.location?.message}
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: "100%", p : 2 }}>
              <InputLabel
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.contact ? "Contact Number*" : "Contact Number*"}
              </InputLabel>
              <PhoneInputController
        name="contact"
        control={control}
        rules={{ required: 'Contact number is required' }}
      />
              {errors?.contact ? (
                <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                  {errors?.contact?.message}
                </Typography>
              ) : null}
            </Box>



            <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  backgroundColor: "#FCFCFD",
                  padding: 2,
                  border: "1px solid #E5E7EB",
                  marginTop: 7,
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  Map
                </Typography>
              </Box>

              <Box style={{ padding: "25px 17px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.Location?.latitude ? "Latitude of Dental Clinic*" : "Latitude of Dental Clinic"}
                </InputLabel>
                <Controller
                  name={`Location.latitude`}
                  rules={{
                    required: "Latitude is required",
                    validate: (value) =>
                      !isNaN(value) && Number(value) >= -90 && Number(value) <= 90
                        ? true
                        : "Latitude must be a number between -90 and 90",
                  }}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={Boolean(errors?.Location?.latitude) ? true : false}
                      placeholder="Enter latitude"
                      sx={{
                        mt: 0,
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.Location?.latitude ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.Location?.latitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.Location?.latitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.Location?.latitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.Location?.latitude ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    {errors?.Location?.latitude?.message}
                  </Typography>
                ) : null}
              </Box>


              <Box style={{ padding: "25px 17px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.Location?.longitude ? "Longitude of Dental Clinic*" : "Longitude of Dental Clinic"}
                </InputLabel>
                <Controller
                  name={`Location.longitude`}
                  rules={{
                    required: "Longitude is required",
                    validate: (value) =>
                      !isNaN(value) && Number(value) >= -180 && Number(value) <= 180
                        ? true
                        : "Longitude must be a number between -180 and 180",
                  }}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={Boolean(errors?.Location?.longitude) ? true : false}
                      placeholder="Enter longitude"
                      sx={{
                        mt: 0,
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.Location?.longitude ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.Location?.longitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.Location?.longitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.Location?.longitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.Location?.longitude ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    {errors?.Location?.longitude?.message}
                  </Typography>
                ) : null}
              </Box>

{/* <Box sx={{mt : 2, mb: 2, ml : 2}}>
          <Button variant='contained' onClick={() => addHeaderLanguage()}>Add Language</Button>
          </Box> */}

          {/* <Divider sx={{mt : 2, mb : 2}}/> */}

            <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              marginTop : 2
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "black",
                }}>Dental Clinic Image</Typography>
            </Box>

              {Boolean(Imgwatch) ? (
                  <Box style={{ padding: "0px 17px 17px" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  padding="23px"
                  borderRadius="8px"
                  sx={{ border: ".5px solid #1A2461" }}
                >
                  <Typography
                    variant="h9_1"
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <ImgIcon />
                    {Imgwatch?.name}
                  </Typography>
                  <ClearIcon
                    onClick={() => setValue("img", null)}
                    sx={{ color: "#1A2461" }}
                  />
                </Stack>
                </Box>
              ) : (
                <Box
                  xs={12}
                  onClick={() => imgFile.current.click()}
                  sx={{
                    border: Boolean(errors.img)
                      ? "1px dashed red"
                      : "1px dashed #1A2461",
                    height: "200px",
                    borderRadius: "8px",
                    backgroundColor: "#F9FBFF",
                    margin: '20px 17px 17px'
                  }}
                >
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    height="100%"
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        height: "100px",
                        width: "100px",
                        borderRadius: "100px",
                        backgroundColor: "#F2F2F2",
                      }}
                    >
                      <UploadFileIcon fill="#1A2461" />
                    </Stack>
                    <Stack mt={2} direction="row" alignItems="center" gap="5px">
                      <Typography variant="h9_1">Click to upload</Typography>
                    </Stack>
                    <Typography variant="h9_5">
                      Allowed formats - JPEG, PNG
                    </Typography>
                  </Stack>
                  <Box sx={{marginTop : '0.3rem'}}>
                      {errors?.img ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please select an Image</Typography> : null}
                    </Box>
                </Box>
              )}
              <Controller
                name="img"
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];

                        if (file && file.type.startsWith("image/")) {
                          field.onChange(file);
                        } else {
                          alert("Please select a valid image file.");
                          field.onChange(null);
                        }

                        e.target.value = null;
                      }}
                      ref={(e) => {
                        imgFile.current = e;
                      }}
                      hidden
                    />
                )}
              />
            <Divider style={{marginTop : '35px'}}/>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0px 17px 13px",
              }}
            >
              <Button 
              disabled={loading}
               variant="contained"
               type="submit"
               sx={{
                 padding: "10px 20px 10px 20px",
                 mt: 2,
                 width: "20%",
                 fontSize: 20,
                 backgroundColor: "rgb(14, 94, 132)",
                 ":hover": { bgcolor: "rgb(14, 94, 132)" },
               }}>
                Confirm
              </Button>
              </Box>
           
        </form>
        </CardContent>
      </Card>
      </Box>
    </>
  );
}
